import { render, staticRenderFns } from "./visual-type-related-scores.vue?vue&type=template&id=207d44aa"
import script from "./visual-type-related-scores.vue?vue&type=script&lang=js"
export * from "./visual-type-related-scores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports